import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { BuyButton } from './ui/BuyButton';
import { BRAND, offerIncludes, CHECKOUT_URL } from '../data/site';
import { usePricing } from '../hooks/usePricing';
interface OfferCardProps {
  showCountdown: boolean;
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function OfferCard({
  showCountdown,
  countdown
}: OfferCardProps) {
  const pricing = usePricing();
  const timeUnits = [{
    value: countdown.hours,
    label: 'Horas'
  }, {
    value: countdown.minutes,
    label: 'Min'
  }, {
    value: countdown.seconds,
    label: 'Seg'
  }];
  return <section id="oferta" className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" aria-labelledby="oferta-titulo" data-id="element-111" data-mp="1af10zlmuils2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-112" data-mp="15evcgebvhfe7">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-overline text-gold-200" data-id="element-113" data-mp="22xeyfk49s5qm">
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-114" data-mp="1y4c0z0wdgc55" />
          Tu acceso
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-115" data-mp="8gl1o787i1nb" />
        </p>
        <h2 className="mt-5 font-serif text-[2.2rem] leading-[1.06] text-cream sm:text-[3rem]" data-id="element-116" data-mp="ddkz5tqzpw2t">
          Ahorrá <strong className="font-semibold" data-id="element-117" data-mp="3vsdnxq26d16c">errores, materiales</strong> y
          frustración con un{' '}
          <span className="italic text-gold-200" data-id="element-118" data-mp="3n9sw0ju3asr">método claro</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[16px] leading-relaxed text-sage-100" data-id="element-119" data-mp="3ltxx7o727txd">
          No es un ebook suelto: es el método completo, con proyectos, recursos y
          criterio práctico para que cada flor que prenses llegue a ser una pieza
          terminada.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-xl" data-id="element-120" data-mp="3gwe6vpx37qp2">
        {showCountdown ? <div className="flex justify-center gap-3" data-editable="countdown-placeholder" data-id="element-121" data-mp="1b24otpocmewg">
            {timeUnits.map(unit => <div key={unit.label} className="w-20 rounded-2xl border border-sage-700 bg-sage-900/60 py-3 text-center" data-id="element-122" data-mp="1f1x0wccyb36k">
                <p className="font-serif text-2xl text-cream" data-id="element-123" data-mp="2j0k2l1okuy5k">{unit.value}</p>
                <p className="mt-0.5 text-[10px] uppercase tracking-[0.16em] text-sage-200" data-id="element-124" data-mp="2f1jizgy9zrhi">
                  {unit.label}
                </p>
              </div>)}
          </div> : null}

        <div className="mt-7 overflow-hidden rounded-4xl bg-cream shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)]" data-id="element-125" data-mp="36qedvet90enp">
          <div className="border-b border-gold-200/70 bg-bone px-6 py-6 text-center" data-id="element-126" data-mp="32qw33bv55jyl">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-terracotta-500" data-id="element-127" data-mp="2xy2v8f4dlvia">
              Oferta por tiempo limitado
            </p>
            <h3 id="oferta-titulo" className="mt-3 font-serif text-[2rem] leading-none text-sage-800" data-id="element-128" data-mp="3qff210sawke0">
              {BRAND.product}
            </h3>
            <p className="mt-2 text-[13px] text-ink-light" data-id="element-129" data-mp="3t0cyubj4nuh5">{BRAND.subtitle}</p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-130" data-mp="1tsf7cvejou5">
            <div className="mb-8 w-full rounded-3xl border-2 border-gold-200/60 bg-bone px-6 py-8 text-center shadow-inner" data-id="element-131" data-mp="1ulczocdv405">
              <p className="text-[12px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-132" data-mp="6uzk9465u9x4">
                Precio Especial
              </p>
              
              <div className="mt-3 flex items-center justify-center gap-3 text-ink-light" data-id="element-133" data-mp="fsjqkrivqwel">
                <span className="text-[14px] font-medium uppercase tracking-wider" data-id="element-134" data-mp="krmhz95xt443">Valor normal:</span>
                <span className="text-[18px] font-bold line-through decoration-terracotta-500/80 decoration-[3px]" data-id="element-135" data-mp="pkfoa1h20kia">
                  {pricing.currency} {pricing.anchor}
                </span>
              </div>
              
              <div className="mt-2 flex items-baseline justify-center gap-2" data-id="element-136" data-mp="ylvz2abs6on1">
                <span className="text-2xl font-bold text-sage-800" data-id="element-137" data-mp="13jxfsolqibvc">{pricing.currency}</span>
                <span className={`font-serif text-[4rem] leading-none text-sage-900 transition-opacity duration-300 sm:text-[5rem] ${pricing.loading ? 'opacity-40' : 'opacity-100'}`} data-id="element-138" data-mp="pvdl7ovhke18">
                  {pricing.loading ? '···' : pricing.price}
                </span>
              </div>
              
              <p className="mt-4 inline-block rounded-full bg-gold-200/50 px-4 py-1.5 text-[11.5px] font-bold uppercase tracking-wider text-sage-900" data-id="element-139" data-mp="6x18xu9a2o1f">
                Pago único · Acceso de por vida
              </p>
            </div>

            <ul className="space-y-3 border-b border-gold-200/70 pb-7" data-id="element-140" data-mp="gwjuug8r0jw4">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-141" data-mp="bvcmaeys7goe">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-142" data-mp="1s9uiuno7bmk3">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-143" data-mp="1nbkq0jpy8y1n" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-144" data-mp="3584ni387gve9">
                    {item}
                  </span>
                </li>)}
            </ul>

            <BuyButton size="xl" label="Quiero acceder ahora" href={CHECKOUT_URL} className="mt-7 w-full" data-id="element-145" data-mp="2wac3wmvgb1l2" />

            <p className="mt-4 flex items-center justify-center gap-1.5 text-[11.5px] text-ink-light" data-id="element-146" data-mp="3ox6p5m03e4zl">
              <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-147" data-mp="3sxyuw59r9rr4" />
              Pago seguro · Acceso inmediato por mail
            </p>
          </div>
        </div>
      </div>
    </section>;
}